﻿package com.ijoin.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class LocaleManager(
    private val preferenceStorage: LanguagePreferenceStorage = createLanguagePreferenceStorage()
) {
    var currentLanguage by mutableStateOf(SupportedLanguages.default)
        private set

    init {
        val storedLanguage = preferenceStorage.getLanguageCode()?.takeIf { it.isNotBlank() }
        val initialLanguage = SupportedLanguages.fromCode(storedLanguage ?: detectSystemLanguageCode())
        currentLanguage = initialLanguage
        GlobalStringsProvider.update(initialLanguage.strings, initialLanguage.code)
        updatePlatformLocale(initialLanguage.code)
    }

    fun setLanguage(language: AppLanguage) {
        if (language == currentLanguage) return
        currentLanguage = language
        GlobalStringsProvider.update(language.strings, language.code)
        updatePlatformLocale(language.code)
        preferenceStorage.saveLanguageCode(language.code)
    }

    fun toggleLanguage() {
        val languages = SupportedLanguages.all
        if (languages.isEmpty()) return
        val currentIndex = languages.indexOf(currentLanguage).takeIf { it >= 0 } ?: 0
        val nextLanguage = languages[(currentIndex + 1) % languages.size]
        setLanguage(nextLanguage)
    }
}

expect fun updatePlatformLocale(languageCode: String)

val LocalLocaleManager = compositionLocalOf { LocaleManager() }

@Composable
fun ProvideLocaleManager(
    localeManager: LocaleManager = LocaleManager(),
    content: @Composable () -> Unit
) {
    CompositionLocalProvider(LocalLocaleManager provides localeManager) {
        content()
    }
}
